import { env } from "./env";

/**
 * The public marketing site, which lives on the apex domain and is served by a
 * separate WordPress install — this app only ever links out to it.
 *
 * Kept env-overridable (VITE_MARKETING_URL) so a staging app can point at a
 * staging marketing site instead of production.
 */
export function getMarketingBaseUrl() {
  return env.marketingUrl;
}

/** Absolute URL for a path on the marketing site, e.g. marketingUrl("/terms"). */
export function marketingUrl(path: string) {
  return `${getMarketingBaseUrl()}${path.startsWith("/") ? path : `/${path}`}`;
}

export const TERMS_URL = marketingUrl("/terms");
export const PRIVACY_URL = marketingUrl("/privacy");
